import React, {useState, useEffect, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import {showToast, commonLogDate, isValidEmail} from '../../common/app_common.js';
import {LoadingSpinner, InputAuto, TagsInputComponent, BadgeChange, useBlockerWithModal} from '../../common/component_common.js';
import {getApiSitesKeyword} from '../../common/fetch_api/site';
import {getApiConfigSiteEndpoint, postApiConfigSiteEndpoint, postApiConfigSiteEndpointEmailTest} from '../../common/fetch_api/configuration';
import {BsChevronExpand, BsPlusSquare, BsTrash} from 'react-icons/bs';
import {DecideWindow} from '../../common/modal_common.js';
import * as xlsx from 'xlsx';

export const View = ({existUpdate, setExistUpdate}) =>
{
    const [update, setUpdate] = useState(false);
    const [callsign, setCallsign] = useState('');
    const [emailAddress, setEmailAddress] = useState([]);

    const [siteEndpointList, setSiteEndpointList] = useState([]);
    const [siteEndpointOrg, setSiteEndpointOrg] = useState([]);
    const [siteUpdateList, setSiteUpdateList] = useState([]);
    const [tbody, setTbody] = useState([]);
    const [siteKeywords, setSiteKeywords] = useState([]);
    const [autoCompleteList, setAutoCompleteList] = useState([]);

    const [loading, setLoading] = useState(false);

    // const [sortHeader, setSortHeader] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');

    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (updatedList) => {
        setSiteUpdateList(updatedList);
        setModalDecide(true);
    };

    function isAdd(is)
    {
        if(is)
        {
            setSiteEndpointList(siteUpdateList);
            // setSortHeader('');
            setSortOrder('asc');
            clearInputs();
            showToast('Site Endpoint added successfully', 'info');
        }
    }
    
    const SetDecideBodyAdd = () => {
        return (
            <div className='text-center'>
                <p>This callsign already exists. Do you want to overwrite the email address?</p>
            </div>
    )};

    const [modalVisible, setModalVisible] = useState(false);
    const [modalCallback, setModalCallback] = useState(null);

    const showModalDecideForRoute = ({ onConfirm }) => {
        setModalVisible(true);
        setModalCallback(() => onConfirm);
    };
    const closeModalDecideForRoute = () => {
        setModalVisible(false);
    };

    useBlockerWithModal(existUpdate, showModalDecideForRoute);

    // DecideWindow에서 OK 클릭 시
    const handleModalOk = (is) => {
        if( is )
        {
            setModalVisible(false);
            if (modalCallback) modalCallback();
        }
    };

    const SetDecideBodyMoveout = () => {
        return (
            <div className='text-center'>
                <p>There are unsaved changes. Are you sure you want to leave this page?</p>
            </div>
    )};

    function clearInputs()
    {
        setCallsign('');
        setEmailAddress([]);
    }

    function updateAutoCompleteList(endpoints, keywords)
    {
        // endpoints와 keywords의 모든 callsign을 합침 (대소문자 변환 제거)
        const endpointCallsigns = endpoints.map(ep => ep.callsign);
        const keywordCallsigns = keywords || [];

        // 두 리스트를 합치고 중복 제거
        const uniqueList = Array.from(new Set([...endpointCallsigns, ...keywordCallsigns]));
        
        // 정렬
        uniqueList.sort((a, b) => {
            return a.localeCompare(b);
        });

        setAutoCompleteList(uniqueList);

        // 디버깅용 로그
        // console.log('Endpoint Callsigns:', endpointCallsigns);
        // console.log('Keyword Callsigns:', keywordCallsigns);
        // console.log('Combined Unique List:', uniqueList);
    }

    const onClickAddInfo = () =>
    {
        // 빈 값 확인
        if (!callsign || callsign.trim() === '')
        {
            showToast('Please input Callsign', 'warning');
            return;
        }
        
        if (emailAddress.length < 1 )
        {
            showToast('Please input E-Mail Address', 'warning');
            return;
        }

        if (!emailAddress.every(isValidEmail)) {
            showToast('Please enter a valid email address (e.g., user@example.com)', 'warning');
            return;
        }

        const isDuplicateCallsign = siteEndpointList.some(
            endpoint => endpoint.callsign === callsign
        );
        const isDuplicateEmail = siteEndpointList.some(
            endpoint => endpoint.callsign === callsign && JSON.stringify(endpoint.email) === JSON.stringify(emailAddress)
        );

        if ( isDuplicateCallsign && isDuplicateEmail )
        {
            showToast('Emails already registered for this callsign.', 'warning');
            // setCallsign('');
        }
        else
        {
            if( isDuplicateCallsign && !isDuplicateEmail )
            {
                // 이미 존재하는 callsign에 대해 이메일 주소만 업데이트
                const updatedList = siteEndpointList.map(endpoint =>
                {
                    if (endpoint.callsign === callsign)
                    {
                        return { 
                            ...endpoint, 
                            email: [...emailAddress].sort((a, b) => a.localeCompare(b)) 
                        };
                    }
                    return endpoint;
                });
                
                showModalDecide(updatedList);
                return;
            }
            else
            {
                const sortedEmails = [...emailAddress].sort((a, b) => a.localeCompare(b));
                const newEndpoint =
                {
                    "callsign": callsign,
                    "email": sortedEmails
                };
                
                setSiteEndpointList([newEndpoint, ...siteEndpointList]);
            }

            // 정렬 상태 초기화
            // setSortHeader('');
            setSortOrder('asc');
            clearInputs();
            showToast('Site Endpoint added successfully', 'info');
        }
    }

    const onClickRemoveInfo = () =>
    {
        if(callsign)
        {
            let newData = siteEndpointList.filter(x => x.callsign !== callsign);
    
            setSiteEndpointList(newData);
            // 정렬 상태 초기화
            // setSortHeader('');
            setSortOrder('asc');
            clearInputs();
        }
        else
        {
            showToast('Please, Choose the Location List!', 'warning');
        }
    }

    // const onChangeAddress = (e) =>
    // {
    //     setEmailAddress(e.target.value);
    // }

    const onClickTest = () =>
    {
        // Callsign과 E-Mail Address 필수 항목 체크
        if (!callsign || callsign.trim() === '') {
            showToast('Please input Callsign', 'warning');
            return;
        }
        
        if ( emailAddress.length < 1 ) {
            showToast('Please input E-Mail Address', 'warning');
            return;
        }

        // 이메일 주소 유효성 검사
        if (!emailAddress.every(isValidEmail)) {
            showToast('Please enter a valid email address (e.g., user@example.com)', 'warning');
            return;
        }

        setLoading(true);

        let sendData =
        {
            "callsign": callsign,
            "email": emailAddress,
        };

        Promise.resolve(postApiConfigSiteEndpointEmailTest(sendData))
        .then(done =>
        {
            setLoading(false);
        })
        .catch(e =>
        {
            setLoading(false);
        });
        
        // emailAddress.forEach((email, index) => {
        //     let sendData =
        //     {
        //         "callsign": callsign,
        //         "email": email,
        //     };

        //     Promise.resolve(postApiConfigSiteEndpointEmailTest(sendData))
        //     .then(done =>
        //     {
        //         setLoading(false);
        //     })
        //     .catch(e =>
        //     {
        //         setLoading(false);
        //     });
        // });
    }

    const onClickSort = (criteria) =>
    {
        setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
        // if (sortHeader === criteria)
        // {
        //     setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
        // }
        // else
        // {
        //     setSortHeader(criteria);
        //     setSortOrder('asc');
        // }
    };

    const inputRef = useRef(null);

    const onClickImport = () =>
    {
        inputRef.current.click();
    }

    const onChangeFile = (e) =>
    {
        const file = e.target.files[0];
        const reader = new FileReader();
    
        reader.onload = (e) =>
        {
            const wb = xlsx.read(e.target.result);
            const sheet = wb.SheetNames;
            if(sheet.length)
            {
                const data = xlsx.utils.sheet_to_json(wb.Sheets[sheet[0]]);
                
                // 데이터 형식 검증
                if (data.length === 0)
                {
                    showToast('File is empty', 'error');
                    return;
                }

                // 첫 번째 항목으로 필수 필드 확인
                const firstItem = data[0];
                if (!firstItem.hasOwnProperty('callsign') || !firstItem.hasOwnProperty('email'))
                {
                    showToast('Invalid file format. Required columns: callsign, email', 'error');
                    return;
                }

                // 모든 항목 검증
                const isValid = data.every(item => {
                    // 필수 필드 존재 확인
                    if (!item.callsign || !item.email)
                    {
                        showToast('All items must have callsign and email', 'error');
                        return false;
                    }
                    
                    // callsign과 email이 문자열인지 확인
                    if (typeof item.callsign !== 'string' || typeof item.email !== 'string')
                    {
                        showToast('Callsign and email must be text', 'error');
                        return false;
                    }

                    return true;
                });

                if (!isValid)
                {
                    return;
                }

                // 데이터 정렬 적용
                const sortedData = [...data].sort((a, b) => {
                    // 1. 알파벳 순서로 먼저 비교 (대소문자 구분 없이)
                    const compareResult = a.callsign.toLowerCase().localeCompare(b.callsign.toLowerCase());
                    if (compareResult !== 0) return compareResult;

                    // 2. 같은 문자일 경우 대문자 우선
                    if (a.callsign !== b.callsign) {
                        if (a.callsign === a.callsign.toUpperCase()) return -1;
                        if (b.callsign === b.callsign.toUpperCase()) return 1;
                    }

                    return 0;
                });

                const normalizedData = sortedData.map(item => ({
                    ...item,
                    email: typeof item.email === 'string'
                        ? item.email.split(',').map(e => e.trim()).filter(e => e)
                        : Array.isArray(item.email) ? item.email : []
                }));

                const sortedEmails = normalizedData.map(item => ({
                    ...item,
                    email: item.email.sort((a, b) => a.localeCompare(b))
                }));

                setSiteEndpointList(sortedEmails);
                // 정렬 상태 설정
                // setSortHeader('callsign');
                setSortOrder('asc');
                showToast('File imported successfully', 'success');
            }
        };
    
        reader.readAsArrayBuffer(file);
    }

    const onClickExport = () =>
    {
        if (!siteEndpointList || siteEndpointList.length === 0)
        {
            showToast('No data to export', 'warning');
            return;
        }

        // const ws = xlsx.utils.json_to_sheet(siteEndpointList);
        const ws = xlsx.utils.json_to_sheet(
            siteEndpointList.map(item => ({
                ...item,
                email: Array.isArray(item.email) ? item.email.join(', ') : item.email
            }))
        );
        const wb = xlsx.utils.book_new();

        let filename = commonLogDate() + '_site_endpoint.csv';
        xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
        xlsx.writeFile(wb, filename)
    }

    const onClickClear = () =>
    {
        setSiteEndpointList([]);
        clearInputs();
    }
    
    const onClickSave = () =>
    {
        const jsonData = siteEndpointList.map(item => ({
            "callsign": item.callsign,
            "email": item.email
        }));

        Promise.resolve ( postApiConfigSiteEndpoint(jsonData) )
        .then( done =>
        {
            runUpdate();
        });
    }

    const runUpdate = () =>
    {
        setUpdate(!update);
    };

    const onClickEndpoint = (item) =>
    {
        setCallsign(item.callsign);
        setEmailAddress(item.email);
    };

    useEffect(() =>
    {
        // Promise.all을 사용하여 두 API 호출을 동시에 처리
        Promise.all([
            getApiConfigSiteEndpoint(),
            getApiSitesKeyword()
        ])
        .then(([endpointData, keywordData]) =>
        {
            console.log('endpointData', endpointData);

            // callsign 기준 정렬
            const sortedEndpointData = endpointData.sort((a, b) => {
                const compareResult = a.callsign.toLowerCase().localeCompare(b.callsign.toLowerCase());
                if (compareResult !== 0) return compareResult;
                if (a.callsign !== b.callsign) {
                    if (a.callsign === a.callsign.toUpperCase()) return -1;
                    if (b.callsign === b.callsign.toUpperCase()) return 1;
                }
                return 0;
            });

            // email 필드를 컴포넌트 내부 포맷(배열)으로 정규화
            const normalizedEndpointData = sortedEndpointData.map(item => {
                if (Array.isArray(item.email)) {
                    // 이미 배열이면 정렬만 수행
                    return {
                        ...item,
                        email: [...item.email].sort((a, b) => a.localeCompare(b)),
                    };
                } else if (typeof item.email === 'string' && item.email.trim().length > 0) {
                    // 문자열이면 단일 이메일을 배열로 감싸고 정렬
                    return {
                        ...item,
                        email: [item.email.trim()],
                    };
                } else {
                    // 그 외(undefined, 빈 문자열 등)는 빈 배열로 통일
                    return {
                        ...item,
                        email: [],
                    };
                }
            });

            setSiteEndpointList(normalizedEndpointData);
            setSiteEndpointOrg(normalizedEndpointData);

            const keywords = keywordData.callsign || [];
            setSiteKeywords(keywords);

            // 두 데이터가 모두 준비된 후 updateAutoCompleteList 호출
            updateAutoCompleteList(normalizedEndpointData, keywords);
        });
    }, [update]);

    useEffect(() => {
        // const sortedList = [...siteEndpointList].sort((a, b) =>
        // {
        //     if (!sortHeader)
        //     {
        //         return 0;  // 정렬 헤더가 없으면 원래 순서 유지
        //     }

        //     const aValue = a[sortHeader];
        //     const bValue = b[sortHeader];

        //     if (sortOrder === 'asc')
        //     {
        //         // 1. 알파벳 순서로 먼저 비교
        //         const compareResult = aValue.toLowerCase().localeCompare(bValue.toLowerCase());
        //         if (compareResult !== 0) return compareResult;

        //         // 2. 같은 문자일 경우 대문자 우선
        //         if (aValue !== bValue) {
        //             if (aValue === aValue.toUpperCase()) return -1;
        //             if (bValue === bValue.toUpperCase()) return 1;
        //         }

        //         return 0;
        //     }
        //     else
        //     {
        //         // desc 정렬일 때는 반대로
        //         const compareResult = bValue.toLowerCase().localeCompare(aValue.toLowerCase());
        //         if (compareResult !== 0) return compareResult;

        //         if (aValue !== bValue)
        //         {
        //             if (bValue === bValue.toUpperCase()) return -1;
        //             if (aValue === aValue.toUpperCase()) return 1;
        //         }

        //         return 0;
        //     }
        // });

        setExistUpdate(JSON.stringify(siteEndpointOrg) !== JSON.stringify(siteEndpointList));

        let sortedList = [];
        if (sortOrder === 'asc')
        {
            sortedList = [...siteEndpointList].sort((a, b) => a.callsign.localeCompare(b.callsign));
        }
        else
        {
            sortedList = [...siteEndpointList].sort((a, b) => b.callsign.localeCompare(a.callsign));
        }

        const rows = sortedList.map((item, index) =>
        {
            const isInvalidCallsign = !siteKeywords.some(keyword => keyword === item.callsign);
        
            return (
                <tr key={index} onClick={() => onClickEndpoint(item)} style={{cursor: 'pointer'}}>
                    <td className={isInvalidCallsign ? 'invalid-callsign' : ''}>{item.callsign}</td>
                    <td>
                        <div className="react-tagsinput">
                            <span>
                                {item.email.map((email, idx) => (
                                    <span key={idx} className="react-tagsinput-tag">
                                        {email}
                                    </span>
                                ))}
                            </span>
                        </div>
                    </td>
                </tr>
            );
        });
        
        setTbody(rows);
    // }, [siteEndpointList, sortHeader, sortOrder, siteKeywords]);
    }, [siteEndpointList, sortOrder, siteKeywords]);

    useEffect(() =>
    {
        const endpoint = siteEndpointList.find(ep => ep.callsign === callsign);

        if (endpoint)
        {
            setEmailAddress(endpoint.email);
        }
        else
        {
            setEmailAddress([]);
        }
    }, [callsign]);
    
    // usePrompt(
    //   existUpdate,
    //   "There are unsaved changes. Are you sure you want to leave this page?"
    // );

    // useEffect(() => {
    //     const handleBeforeUnload = (e) => {
    //         if (existUpdate) {
    //             console.log('Before unload triggered due to unsaved changes');
    //             e.preventDefault();
    //             e.returnValue = '';
    //         }
    //     };

    //     window.addEventListener('beforeunload', handleBeforeUnload);
    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, [existUpdate]);

    return (
        <div className="tab-pane show active">
            <div className="section site-endpoint-area mt-3">
                <div className="section-title">Endpoint</div>
                <div className="d-flex mt-1">
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">Callsign</div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                        <div className="callsign-input">
                            <InputAuto 
                                data={autoCompleteList} 
                                selectedVal={callsign} 
                                setSelectedVal={setCallsign}
                                onSelect={(selected) => {
                                    setCallsign(selected);
                                    const endpoint = siteEndpointList.find(ep => ep.callsign === selected);
                                    if (endpoint) {
                                        setEmailAddress(endpoint.email);
                                    } else {
                                        setEmailAddress([]);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 d-flex">
                        <Button variant='primary' className="btn btn-icon ms-2" onClick={onClickAddInfo}><BsPlusSquare/></Button>
                        <Button variant='danger' className="btn btn-icon ms-2" onClick={onClickRemoveInfo}><BsTrash/></Button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">E-Mail Address</div>
                    <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 ps-1">
                        <TagsInputComponent tags={emailAddress} setTags={setEmailAddress}/>
                        {/* <input className="form-control input-box" type="text" value={emailAddress} onChange={onChangeAddress}/> */}
                    </div>
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 d-flex">
                        <Button variant='success' className="btn btn-sm ms-2" onClick={onClickTest}>Test</Button>
                    </div>
                </div>
                <hr />
                <div className="d-flex flex-wrap">
                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-3 label-box">Endpoint List</div>
                    <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-9 col-sm-12 col-12 ps-1 mb-2">
                        <div className="site-endpoint-list-table">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th className="sorting" onClick={() => {onClickSort('callsign')}}>Callsign<BsChevronExpand /></th>
                                        <th className="sorting">E-Mail Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tbody}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-2 col-sm-2 col-2">
                        <div className="d-flex list-btns">
                            <Button variant='primary' className="btn btn-sm ms-2 mb-2" htmlFor='file' onClick={onClickImport}>Import</Button>
                            <input type="file" id='file' ref={inputRef} onChange={onChangeFile} accept=".xlsx, .xls, .csv"/>
                            <Button variant='primary' className="btn btn-sm ms-2 mb-2" onClick={onClickExport}>Export</Button>
                            <Button variant='danger' className="btn btn-sm ms-2" onClick={onClickClear}>Clear</Button>
                        </div>
                    </div>
                </div>
                <div className="d-flex my-2 ms-2">
                    <Button variant="primary" className="btn btn-sm btn-badge-change" onClick={onClickSave}>Save<BadgeChange show={existUpdate}/></Button>
                    <span className={`ms-3 mt-1 text-warning ${existUpdate?"":"d-none"}`}>There are unsaved changes. Please click the Save button to apply your changes.</span>
                </div>
            </div>
            <LoadingSpinner loading={loading}/>
            {modalDecide&&<DecideWindow result={isAdd} show={modalDecide} handleClose={closeModalDecide} body={<SetDecideBodyAdd/>} okButtonTxt={'OK'}/>}
            {modalVisible&&<DecideWindow result={handleModalOk} show={modalVisible} handleClose={closeModalDecideForRoute} body={<SetDecideBodyMoveout />} okButtonTxt={'OK'}/>}
        </div>
    )
}
